// Dynamic environment loader that gets replaced at build time
import { Environment } from './environment';

// Default environment - will be replaced by webpack based on NODE_ENV
let environment: Environment;

// This will be replaced by webpack DefinePlugin
const ENV_NAME = typeof __ENVIRONMENT__ !== 'undefined' ? __ENVIRONMENT__ : 'dev';

switch (ENV_NAME) {
  case 'prod':
  case 'production':
    environment = require('./environment.prod').environment;
    break;
  case 'dev':
  case 'development':
  default:
    environment = require('./environment').environment;
    break;
}

export { environment };
